import React, { useEffect, useState,useContext } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  IconButton,
  Button,
  Alert
} from '@mui/material';
import { Visibility, Edit } from '@mui/icons-material';
import studioApi from '../../api/studioApi';
import contribuenteApi from '../../api/contribuenteApi';
import { AuthContext } from '../../auth/AuthContext';
import { useParams, useNavigate } from 'react-router-dom';

export default function StudioDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [err, setErr] = useState(null);
  const [studio, setStudio] = useState(null);
  const [contribuenti, setContribuenti] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [contribuentiDisponibili, setContribuentiDisponibili] = useState([]);
  const [selezionati, setSelezionati] = useState([]);
  const pageSize = 10;

  useEffect(() => {
    fetchStudio();
    fetchContribuenti(0);
    fetchContribuentiDisponibili();
  }, [id]);

  const fetchStudio = () => {
    studioApi.get(id)
      .then(r => setStudio(r.data))
      .catch(err => console.error('Errore caricamento studio:', err));
  };

  const fetchContribuenti = (page) => {
      console.log("studio id ",id);
    contribuenteApi.listbystudio(id, { page, size: pageSize })
      .then(r => {
        setContribuenti(r.data.content || []);
        setTotalPages(r.data.totalPages || 0);
        setPage(r.data.number || 0);
      })
      .catch(err => console.error('Errore caricamento contribuenti:', err));
  };
  const fetchContribuentiDisponibili = () => {
  contribuenteApi.liststudioassociable()
    .then(r => setContribuentiDisponibili(r.data || []))
    .catch(err => console.error('Errore contribuenti disponibili:', err));
  };

  const toggleSelezionato = (contribuenteId) => {
    setSelezionati(prev =>
      prev.includes(contribuenteId)
        ? prev.filter(id => id !== contribuenteId)
        : [...prev, contribuenteId]
    );
  };
    const associaContribuenti = async () => {
      if (selezionati.length === 0) return;

      try {
        setErr(null);
        await studioApi.associaContribuenti(id, selezionati);
        setSelezionati([]);
        fetchContribuentiDisponibili();
        fetchContribuenti(0);
        fetchStudio(); // aggiorna contratto studio
      } catch (err) {
        console.error('Errore associazione contribuenti', err);
        setErr(extractErrorMessage(err));
      }
    };
  if (!studio) return <div>Loading...</div>;
  console.log("studio",studio);
  const extractErrorMessage = (error) => {
    if (!error) return 'Errore sconosciuto';
    if (error.response?.data) return JSON.stringify(error.response?.data);
    if (!error.response) {
      return "L'elaborazione richiede più tempo del previsto. Riprova.";
    }
    return error.message || JSON.stringify(error);
  };
  return (
    <Container>
      <Typography variant="h4">
        Studio: {studio.username || studio.nome}
      </Typography>

      {/* CARD STUDIO */}
      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Typography>
            Ragione sociale: {studio.ragionesociale}
          </Typography>
          <Typography>
            Partita IVA: {studio.partitaIVA}
          </Typography>
           <Typography>
             Codice fiscale: {studio.codiceFiscale}
           </Typography>
           <Typography>
             Indirizzo: {studio.indirizzo}
           </Typography>
           <Typography>
             Telefono: {studio.telefono}
           </Typography>
             <Typography>
               Email: {studio.email}
             </Typography>
          <Typography>
            <strong>Contratto:</strong>{' '}
            {studio.contratto ? studio.contratto.tipo : 'Nessuno'}
          </Typography>

          <Button
            sx={{ mt: 1 }}
            variant="outlined"
            onClick={() => navigate(`/studi/edit/${id}`)}
          >
            Modifica Studio
          </Button>
        </CardContent>
      </Card>
      {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
    <Typography variant="h6" sx={{ mt: 4 }}>
      Contribuenti disponibili (non associati)
    </Typography>

    <Button
      variant="contained"
      sx={{ my: 1 }}
      disabled={selezionati.length === 0}
      onClick={associaContribuenti}
    >
      Associa selezionati allo studio
    </Button>

    <Table>
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell>Nome</TableCell>
          <TableCell>Cognome</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {contribuentiDisponibili.map(c => (
          <TableRow key={c.id}>
            <TableCell>
              <input
                type="checkbox"
                checked={selezionati.includes(c.id)}
                onChange={() => toggleSelezionato(c.id)}
              />
            </TableCell>
            <TableCell>{c.nome}</TableCell>
            <TableCell>{c.cognome}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      {/* CONTRIBUENTI */}
      <Typography variant="h6" sx={{ mt: 3 }}>
        Contribuenti
      </Typography>

      <Button
        variant="contained"
        sx={{ my: 1 }}
        onClick={() => navigate(`/contribuenti/create?userId=${studio.utenteId}`)}
      >
        Aggiungi Contribuente
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>Cognome</TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {contribuenti.map(c => (
            <TableRow key={c.id}>
              <TableCell>{c.nome}</TableCell>
              <TableCell>{c.cognome}</TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => navigate(`/contribuenti/${c.id}`)}
                  >
                    <Visibility />
                  </IconButton>

                  <IconButton
                    color="secondary"
                    size="small"
                    onClick={() => navigate(`/contribuenti/edit/${c.id}`)}
                  >
                    <Edit />
                  </IconButton>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* PAGINAZIONE – STESSI BOTTONI NUMERICI */}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? 'contained' : 'outlined'}
            onClick={() => fetchContribuenti(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>
    </Container>
  );
}